<template>
  <span class="badge badge-md badge-danger m-1 p-1">必須</span>
</template>

<script>
export default {

};
</script>